import React from 'react';
import commonConstant from '../../common/_commonConstant';
import { problemName, validateToShowDash } from '../../helpers';

export const customerType = (getParkingReport, buildingID) => {
  try {
    return (
      (buildingID &&
        getParkingReport.customer.customerType === commonConstant.customerTypeMember &&
        getParkingReport.memberBuilding.buildingID === buildingID) ?
        'member'
        : 'visitor'
    );
  } catch (error) {
    return null;
  }
};

export const createBy = getParkingReport => {
  try {
    const createBy = getParkingReport.createdBy ? getParkingReport.createdBy : getParkingReport.parking.createdBy ? getParkingReport.parking.createdBy : null;

    return createBy ? 'Manual created' : 'Auto created';
  } catch (error) {
    return 'Auto created';
  }
};

export const totalTimePark = getParkingReport => {
  try {
    return getParkingReport.parkingTimeIn && getParkingReport.parkingTimeOut ?
      new Date(getParkingReport.parkingTimeOut) - new Date(getParkingReport.parkingTimeIn)
      : null;
  } catch (error) {
    return null;
  }
};

export const tagProblem = (getParkingReport, className) => {
  try {
    if (!getParkingReport.parkingProblem && getParkingReport.parkingProblem.length === 0) {
      return null;
    }
    const checkTypeProblem = [false, false, false, false, false, false, false];
    let sum = 0;
    getParkingReport.parkingProblem.some(ele => {
      if (sum === 6) {
        return true;
      } else if (!checkTypeProblem[indexArray(ele.problem.problemCode)] && indexArray(ele.problem.problemCode)) {
        sum += 1;
        checkTypeProblem[indexArray(ele.problem.problemCode)] = validateToShowDash(problemName(ele));
      }
      return null;
    });
    return (
      <div className="box-tag-problem">
        {
          checkTypeProblem[1] ?
            <span
              id="tag-problem-read-license-plate"
              className={`problem-item problem-code-car-plate${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[1]}
            </span>
            : null
        }
        {
          checkTypeProblem[2] ?
            <span
              id="tag-problem-barrier"
              className={`problem-item problem-code-barrier${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[2]}
            </span>
            : null
        }
        {
          checkTypeProblem[3] ?
            <span
              id="tag-problem-payment"
              className={`problem-item problem-code-payment${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[3]}
            </span>
            : null
        }
        {
          checkTypeProblem[4] ?
            <span
              id="tag-problem-overdue"
              className={`problem-item problem-code-overdue${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[4]}
            </span>
            : null
        }
        {
          checkTypeProblem[5] ?
            <span
              id="tag-problem-other"
              className={`problem-item problem-code-other${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[5]}
            </span>
            : null
        }
        {
          checkTypeProblem[6] ?
            <span
              id="tag-problem-physical-damage"
              className={`problem-item problem-code-physical-damage${className ? ` ${className}` : ''}`}
            >
              {checkTypeProblem[6]}
            </span>
            : null
        }
      </div>
    );
  } catch (error) {
    return null;
  }
};

const indexArray = key => {
  try {
    switch (key) {
      case commonConstant.vehicleLicensePlateProblem:
        return 1;
      case commonConstant.barrierProblem:
        return 2;
      case commonConstant.paymentProblem:
        return 3;
      case commonConstant.overdueProblem:
        return 4;
      case commonConstant.otherProblem:
        return 5;
      case commonConstant.physicalDamageProblem:
        return 6;
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const totalParkingTimeMinutes = getParkingReport => {
  try {
    return getParkingReport.parking.parkingTotalParkingTimeMinutes || getParkingReport.parking.parkingTotalParkingTimeMinutes === 0 ? getParkingReport.parking.parkingTotalParkingTimeMinutes : null;
  } catch (error) {
    return null;
  }
};

export const parkingTimeOut = getParkingReport => {
  try {
    const timeOut = getParkingReport.parkingTimeOut ? getParkingReport.parkingTimeOut : getParkingReport.parking.parkingTimeOut ? getParkingReport.parking.parkingTimeOut : null;

    if (getParkingReport.parkingTimeOut === '0001-01-01T00:00:00Z'){
      return null;
    }

    return timeOut ? new Date(timeOut).setHours(new Date(timeOut).getHours()) : null;
  } catch (error) {
    return null;
  }
};


export const totalVehicles = getParkingReport => {
  try {
    return getParkingReport.metadata.summary.totalVehicles || getParkingReport.metadata.summary.totalVehicles === 0 ? getParkingReport.metadata.summary.totalVehicles : null;
  } catch (error) {
    return null;
  }
};

export const totalCar = getParkingReport => {
  try {
    return getParkingReport.metadata.summary.totalCars || getParkingReport.metadata.summary.totalCars === 0 ? getParkingReport.metadata.summary.totalCars : null;
  } catch (error) {
    return null;
  }
};

export const totalMotorcycle = getParkingReport => {
  try {
    return getParkingReport.metadata.summary.totalMotorcycles || getParkingReport.metadata.summary.totalMotorcycles === 0 ? getParkingReport.metadata.summary.totalMotorcycles : null;
  } catch (error) {
    return null;
  }
};

export const reportTotalPaymentAmount = getParkingReport => {
  try {
    return getParkingReport.metadata.summary.totalPaymentAmount || getParkingReport.metadata.summary.totalPaymentAmount === 0 ? getParkingReport.metadata.summary.totalPaymentAmount : null;
  } catch (error) {
    return null;
  }
};

export const labelVehicleType = getParkingReport => {
  try {
    const type = getParkingReport.vehicleType ? getParkingReport.vehicleType : getParkingReport.vehicle.vehicleType ? getParkingReport.vehicle.vehicleType : getParkingReport ? getParkingReport : '';

    switch (type) {
      case commonConstant.vehicleTypeMotorcycle:
        return 'รถจักรยานยนต์';
      case commonConstant.vehicleTypeCar:
        return 'รถยนต์';
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const labelPaymentMethod = getParkingReport => {
  try {
    switch (getParkingReport.paymentMethod) {
      case commonConstant.paymentMethodCash:
        return 'Cash';
      case commonConstant.paymentMethodCreditCard:
        return 'Credit Card';
      case commonConstant.paymentMethodPPMobile:
      case commonConstant.paymentMethodPPKiosk:
      case commonConstant.paymentMethodPPTablet:
      case commonConstant.paymentMethodPPKioskParkingGate:
        return 'EZY Payment';
      case commonConstant.paymentMethodLinePay:
        return 'Line Pay';
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const paymentUpdatedAt = getParkingReport => {
  try {
    return getParkingReport.paymentUpdatedAt ? getParkingReport.paymentUpdatedAt : null;
  } catch (error) {
    return null;
  }
};

export const totalTenantMembers = getParkingReport => {
  try {
    return getParkingReport.metadata.summary.totalTenantMembers || getParkingReport.metadata.summary.totalTenantMembers === 0 ? getParkingReport.metadata.summary.totalTenantMembers : null;
  } catch (error) {
    return null;
  }
};

export const totalRecords = getParkingReport => {
  try {
    return getParkingReport.metadata.pagination.totalRecords >= 0 ? getParkingReport.metadata.pagination.totalRecords : getParkingReport.data.length;
  } catch (error) {
    return null;
  }
};

export const totalParkingDayConfigRecords = getParkingDayConfig => {
  try {
    return getParkingDayConfig.data.parkingDayConfigMetaData.pagination.totalRecords >= 0 ? getParkingDayConfig.data.parkingDayConfigMetaData.pagination.totalRecords : getParkingDayConfig.data.parkingDayConfig.length;
  } catch (error) {
    return null;
  }
};

export const paymentID = getParkingReport => {
  try {
    return getParkingReport.paymentID ? getParkingReport.paymentID : null;
  } catch (error) {
    return null;
  }
};
